var DRAFT_KEY = 'saito:nftstudio:draft:v1';
function loadDraft(storage) {
  var _draft;
  var raw = storage.getItem(DRAFT_KEY);
  if (!raw) {
    return null;
  }
  var draft;
  try {
    draft = JSON.parse(raw);
  } catch (_unused) {
    return null;
  }
  if (((_draft = draft) === null || _draft === void 0 ? void 0 : _draft.version) !== 1 || !['js', 'css'].includes(draft.type) || typeof draft.source !== 'string' || typeof draft.title !== 'string') {
    return null;
  }
  return draft;
}
function saveDraft(storage, draft) {
  var saved = {
    version: 1,
    title: String(draft.title || ''),
    type: draft.type === 'css' ? 'css' : 'js',
    source: String(draft.source || ''),
    savedAt: new Date().toISOString()
  };
  storage.setItem(DRAFT_KEY, JSON.stringify(saved));
  return saved;
}
module.exports = {
  DRAFT_KEY: DRAFT_KEY,
  loadDraft: loadDraft,
  saveDraft: saveDraft
};